var React = require('react');

function IBookmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"}));
}

IBookmark.defaultProps = {"viewBox":"0 0 384 512"};

module.exports = IBookmark;

IBookmark.default = IBookmark;
